import React from 'react';
import { useRouter } from 'next/navigation';
import Link from 'components/commercetools-ui/atoms/link';
import CartIcon from 'components/icons/cart';
import { useFormat } from 'helpers/hooks/useFormat';
import { useCart } from 'frontastic';
import Image, { FrontasticImage } from 'frontastic/lib/image';

export interface Props {
  logo: FrontasticImage;
  mode?: string;
  isCartRequired?: boolean;
  isCheckoutPage?: boolean;
}

const Header: React.FC<Props> = ({ logo, isCartRequired, isCheckoutPage = false }) => {
  const { totalItems: totalCartItems } = useCart();
  const { formatMessage: formatCartMessage } = useFormat({ name: 'cart' });
  const router = useRouter();

  const onCartClicked = () => {
    // setIsDrawerOpen(true);
    // setMenuState('cart');
    router.push('/cart/');
  };

  return (
    <div className="flex items-center justify-between border-b border-neutral-400 bg-white px-16 py-18 md:p-24 lg:px-48 lg:py-28">
      {!isCheckoutPage ? (
        <a href="/">
          <div className="relative h-[36px] w-[208px] lg:h-[44px] lg:w-[259px]">
            <Image {...logo} style={{ objectFit: 'contain' }} fill />
          </div>
        </a>
      ) : (
        <div className="relative h-[36px] w-[208px] cursor-pointer lg:h-[44px] lg:w-[259px]">
          <Image {...logo} style={{ objectFit: 'contain' }} fill />
        </div>
      )}

      <div className="h-40 w-fit">
        <div
          title={formatCartMessage({ id: 'myCart', defaultMessage: 'My Cart' })}
          className="h-fit cursor-pointer border-secondary-black pb-8 hover:border-b-2"
          onClick={onCartClicked}
        >
          {isCartRequired !== false && (
            <CartIcon
              className="text-24 text-secondary-black"
              totalCartItems={totalCartItems}
              counterClassName="-translate-y-1/4"
            />
          )}
        </div>
      </div>
      {/* <Drawer
        isOpen={isCartSlideoutOpen}
        direction="right"
        className="w-[90%] max-w-[380px] bg-white"
        onClose={() => setIsCartSlideoutOpen(false)}
      >
        <Slideout
          state="cart"
          onClose={() => setIsCartSlideoutOpen(false)}
          enableWishlistState={false}
          {...emptyState}
        />
      </Drawer> */}
    </div>
  );
};

export default Header;
